import { FC } from 'react';
import { RadioGroupProps, RadioProps } from 'antd';
import { Radio as AntRadio } from 'antd';

export const Radio: FC<RadioProps> = ({ ...props }) => {
  return <AntRadio {...props} checked={props.checked ?? false} />;
};

export const RadioGroup: FC<RadioGroupProps> = ({ ...props }) => {
  return <AntRadio.Group {...props} />;
};
